import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core";

import AppContainer from "../common/AppContainer";

import * as authActions from "./actions";
import * as navActions from "../common/actions";

import { authLoginSuccess } from "./actions";
import { reloadAll } from "../common/orm";
import { store } from "../../index"

const styles = (theme) => ({
    marginTopMain: {
        marginTop: 24,
    },
    marginBottomMain: {
        [theme.breakpoints.up("md")]: {
            marginBottom: 72,
        },
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
});

class EntraSuccess extends Component {
    componentDidMount() {
        const _this = this;
        setTimeout(function() { // Make sure the store initializes before running this
            fetch("/_allauth/browser/v1/auth/session")
                .then(response => {
                    if (response.status === 200) {
                        return response.json().then(data => {
                            store.dispatch(authLoginSuccess(data.data.user));
                            store.dispatch(reloadAll());
                            _this.props.history.push("/dashboard");
                            // TODO: Replicate loginSubmit() history?
                        });
                    }
                })
        }, 500)
    };

    render() {
        const { classes } = this.props;

        return (
            <AppContainer>
                <Grid container spacing={5} justifyContent="center">
                    <Grid item xs={11} md={8} lg={6} xl={4}>
                        <Typography variant="h6" gutterBottom className={classes.marginTopMain}>
                            <b>Welcome to the MS4Front Data Management Platform</b>
                        </Typography>
                        <Typography variant="body1" className={classes.marginBottomMain}>
                        A Software as a Service (SaaS) platform to tackle organizations most challenging data management needs. Our platform provides configurable data entry forms, GIS integration and reporting tools.  
                        Our roots stem from helping City and Counties with their MS4 permit tracking but recently our system has been extending to assist numerous other organizations. Those include grant, conservation and regulatory permit program management.
                        </Typography>
                        <Typography variant="h6" style={{textAlign:"center"}}>
                            Authenticating... Please wait
                            <CircularProgress
                                size={72}
                                style={{ display: "table", marginLeft: "auto", marginRight: "auto", zIndex:90000 }}
                            /> 
                        </Typography>
                    </Grid>
                </Grid>
            </AppContainer>
        )
    }
}
EntraSuccess.displayName = "EntraSuccess";
EntraSuccess = connect((state) => ({ authState: state.auth }), {
    ...authActions,
    ...navActions,
})(EntraSuccess);

export default withStyles(styles)(withRouter(EntraSuccess));
